import React from 'react';
import {
  ProductTypeCssClasses,
  ProductTypeTitles,
} from '../../../../modules/Products/pages/products/ProductsUIHelpers';

export function TypeColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `label label-lg label-light-${
      ProductTypeCssClasses[getTitleInd(row.typeCode)]
    } label-inline`;
  };
  function getTitleInd(typeCode) {
    switch (typeCode) {
      case 'P':
        return 1;
      case 'G':
        return 2;
      case 'B':
        return 3;
      case 'S':
        return 4;
      default:
        return 1;
    }
  }
  return (
    <span className={getLabelCssClasses()}>
      {ProductTypeTitles[getTitleInd(row.typeCode)]}
    </span>
  );
}
